<template>
  <div id="not-found" class="text-center d-flex justify-content-center align-items-center h-100">
    <div>
      <h1>
        <i class="ti ti-fw ti-2x ti-warning" /><br>
        {{ $t(`error.${code}.title`) }}
      </h1>
      <p>{{ $t(`error.${code}.message`) }}</p>
      <b-button v-if="get().oauth" :to="{ name: 'logout'}">
        {{ $t(`error.${code}.bt`) }}
      </b-button>
      <b-button v-else :href="pcieUrl">
        {{ $t(`error.${code}.bt`) }}
      </b-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ErrorView',
    props: {
      code: {
        type: String,
        default: '0',
      },
    },
    computed: {
      pcieUrl() {
        return this.get().parameters.monpcie.value;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
